import "./App.css"
import Header from "./components/Header"
import Select from "./components/Select"
import Result from "./components/Result"
import Footer from "./components/Footer"
import { useState } from "react"


const App = () => {
  const [result, setResult] = useState([])

  function handleClick(newItem) {
    setResult([...result, newItem])
    setCounts([...counts, 1])
  }

  const [counts, setCounts] = useState(Array(result.length).fill(1))

  const handleCountChange = (event, index) => {
    const newCounts = [...counts]
    newCounts[index] = event.target.value
    setCounts(newCounts)
  }
  

  function removeItem(index) {
    if (result.length === 1) {
      setResult([]);
      setCounts([]);
    } else {
      const updatedListResult = result.filter((item, i) => i !== index);
      setResult(updatedListResult)
      const updatedListCounts = counts.filter((count, i) => i !== index)
      setCounts(updatedListCounts)
    }
  }

  return (
    <div className="app">
  
      <Select addItem={handleClick} />
      <Result result={result} counts={counts} handleCountChange={handleCountChange} removeItem={removeItem}  />
      <Footer />
    </div>
  )
}

export default App
